import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * Uses DOMPurify with minimal configuration to preserve style and data attributes
 * @param {string} dirty - The HTML string to sanitize
 * @returns {string} - Sanitized HTML string safe for use with dangerouslySetInnerHTML
 */
export const sanitizeHTML = (dirty) => {
    if (!dirty) {
        return '';
    }

    // DOMPurify default is safe, but we need to allow 'style' and 'data-testid' attributes
    // that are used in the application. All dangerous elements are automatically removed.
    return DOMPurify.sanitize(dirty, {
        ALLOWED_ATTR: ['href', 'target', 'rel', 'style', 'data-testid'],
    });
};

